export const getInitials = (obj: { names: string; lastNames: string }) => {
  if (!obj.names || !obj.lastNames) return "-";
  return (obj.names?.charAt(0) + obj.lastNames?.charAt(0)).toUpperCase();
};

export const getFullName = (obj: { names: string; lastNames: string }) => {
  if (!obj.names || !obj.lastNames) return "-";
  return `${obj.names} ${obj.lastNames}`;
};
